import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-13532660"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "support-title" }, "支持拍照批改/拍照对答案的图书", -1))
const _hoisted_3 = { class: "support-list" }
const _hoisted_4 = { class: "support-book" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "support-book-title" }
const _hoisted_7 = {
  key: 0,
  class: "support-footer"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "support-footer-left" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "support-footer-mid" }, "更多图书 敬请期待", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "support-footer-right" }, null, -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WrongPage = _resolveComponent("WrongPage")!
  const _component_ActionBar = _resolveComponent("ActionBar")!

  return ($setup.isLoadWrong)
    ? (_openBlock(), _createBlock(_component_WrongPage, {
        key: 0,
        showActionBar: $setup.showActionBar,
        onClickRefresh: $setup.clickRefresh
      }, null, 8, ["showActionBar", "onClickRefresh"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.showActionBar)
          ? (_openBlock(), _createBlock(_component_ActionBar, {
              key: 0,
              onGoBack: $setup.goBack,
              actionBarInfo: $setup.actionBarInfo,
              backIcon: $setup.backIcon,
              needShare: $setup.needShare
            }, null, 8, ["onGoBack", "actionBarInfo", "backIcon", "needShare"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "support-container",
          style: _normalizeStyle({ paddingTop: $setup.actionBarHeight + 'px' })
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bookList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(), _createElementBlock("img", {
                  class: "support-image",
                  src: item.image_url,
                  key: item.id
                }, null, 8, _hoisted_5)),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
              ]))
            }), 256))
          ]),
          ($setup.isShowFooter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
            : _createCommentVNode("", true)
        ], 4)
      ]))
}